import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ngSelectSortBy'
})
export class NgSelectSortByPipe implements PipeTransform {
  transform(items: any[], key: string): any[] {
    if (!items || !Array.isArray(items)) {
      return [];
    }

    if (!items?.every((item) => item.hasOwnProperty(key))) {
      return items;
    }

    const sortFunct = this.getSortFunct(items[0][key]);

    return items.sort((a, b) => {
      return sortFunct(a[key], b[key]);
    });
  }

  private getSortFunct(varToEvaluate: any): any {
    if (varToEvaluate instanceof Date) {
      return this.sortDates;
    }
    if (typeof varToEvaluate === 'number') {
      return this.sortNumbers;
    }
    if (typeof varToEvaluate === 'string') {
      return this.sortStrings;
    }
    return () => {};
  }

  private sortStrings(a: any, b: any): number {
    return (a.toString()?.trim() ?? '').localeCompare(b.toString()?.trim() ?? '');
  }

  private sortNumbers(a: any, b: any): number {
    return Number(a) - Number(b);
  }

  private sortDates(a: Date, b: Date) {
    return new Date(a).getTime() - new Date(b).getTime();
  }

}
